import React from "react";
import "./free-spin-card.scss";
import IconPlay from "../../../mui/JSXIcons/IconPlay";
import { useTranslation } from "react-i18next";
import "./free-spin-card.scss";
import ShowContainer from "../../../mui/ShowContainer";
import CusButton from "../../../mui/custom_button/CusButton";
import CusImage from "../../../custom_image/CusImage";

/**
 * @typedef {Object} Game
 * @property {number} gameId - Game ID.
 * @property {string} image - Image URL.
 * @property {string} name - Name of the game.
 * @property {string} game - Provider of the game.
 * @property {string} freespins - Number of freespins.
 * @property {Object} bet
 * @property {string} bet.totalBet - Rate of the game.
 * @property {string} wager - Wagering requirements.
 * @property {string} cashout - Cash-out limit.
 *
 * @param {Object} props - The game properties.
 * @param {Game} props.game - The game object.
 */

export default function FreeSpinCardGame({ game, onPlayBtn }) {
  const { t } = useTranslation();

  return (
    <div className="free-spin__bonus__game" key={game.id}>
      <div className="free-spin__bonus__game__img">
        <CusImage url={game.image} alt={"image " + game.name} />
      </div>

      <div className="free-spin__bonus__game__info__fields">
        <span className="free-spin__bonus__game__info__title">
          <IconPlay />
          <h4>{t(game.name)}</h4>

          <ShowContainer condition={game.provider}>
            <span>({game.provider})</span>
          </ShowContainer>
        </span>

        <span className="field">
          <span className="field__name">{t("Freespins")}</span>
          <span className="field__value">{game.freespins}</span>
        </span>
        <span className="field">
          <span className="field__name">{t("Bet")}</span>
          <span className="field__value">{game.bet.totalBet}</span>
        </span>
        <span className="field">
          <span className="field__name">{t("Wager")}</span>
          <span className="field__value">{game.wager}</span>
        </span>
        <span className="field">
          <span className="field__name">{t("Cash out")}</span>
          <span className="field__value">{game.cashout}</span>
        </span>

        <ShowContainer condition={onPlayBtn}>
          <CusButton color="primary" border text="Play" onClick={onPlayBtn} />
        </ShowContainer>
      </div>
    </div>
  );
}
